import { ChartConfig, ChartIndicator } from "@cmp-src/primitives/chart";

/** The legend of the team week chart: in office and favorites, in the colours of `chartConfig`. */
export const InOfficeChartLegend = ({
  chartConfig
}: {
  chartConfig: ChartConfig;
}) => (
  <div className="flex flex-col gap-2 font-normal -mt-1">
    <div className="flex items-center gap-2">
      <ChartIndicator
        indicator={chartConfig.inOffice.indicator || "dot"}
        nestLabel={false}
        indicatorColor={chartConfig.inOffice.color || "#000"}
      />
      <span
        className="text-content font-[400] font-inter"
        style={{ fontSize: 13 }}
      >
        In Office
      </span>
    </div>
    <div className="flex items-center gap-2">
      <ChartIndicator
        indicator={chartConfig.favorite.indicator || "dot"}
        nestLabel={false}
        indicatorColor={chartConfig.favorite.color || "#000"}
      />
      <span
        className="text-content font-[400] font-inter"
        style={{ fontSize: 13 }}
      >
        Favorite
      </span>
    </div>
  </div>
);
